import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { AuthLayout } from "@/components/AuthLayout";
import { Field, BigButton } from "@/components/Field";
import { api, errMsg } from "@/lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [pw, setPw] = useState({ a: "", b: "" });
  const [busy, setBusy] = useState(false);
  const token = params.get("token");

  const submit = async (e) => {
    e.preventDefault();
    if (pw.a !== pw.b) return toast.error("As senhas não conferem");
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw.a });
      toast.success("Senha redefinida! Faça login com a nova senha.");
      navigate("/login");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthLayout title="Nova senha" subtitle="Crie uma nova senha para sua conta.">
      {!token ? (
        <p className="text-[#B05A40]" data-testid="reset-invalid-token">Link inválido. Solicite um novo link de recuperação.</p>
      ) : (
        <form onSubmit={submit} className="space-y-5" data-testid="reset-password-form">
          <Field label="Nova senha" id="pw1" type="password" minLength={6} required value={pw.a} onChange={(e) => setPw({ ...pw, a: e.target.value })} data-testid="reset-password-input" />
          <Field label="Confirmar nova senha" id="pw2" type="password" minLength={6} required value={pw.b} onChange={(e) => setPw({ ...pw, b: e.target.value })} data-testid="reset-password-confirm-input" />
          <BigButton type="submit" disabled={busy} data-testid="reset-submit-button">
            {busy && <Loader2 className="h-5 w-5 animate-spin" />} Salvar nova senha
          </BigButton>
        </form>
      )}
      <p className="mt-6 text-center">
        <Link to="/login" className="font-semibold text-[#1E4D2B] hover:underline" data-testid="back-to-login-link">Voltar para o login</Link>
      </p>
    </AuthLayout>
  );
}
